<template>
    <div class="container">
        <div class="pt-5">
            <h1 class="h3 text-primary">Settings for {{companyDetails.name}}</h1>
            <div class="py-2">

             <settings-menu></settings-menu>
            </div>
            <div class="row py-3 border-bottom">
                <div class="col-md-6 col-sm-12">
                    <!-- <h3 class="h3">{{companyDetails.name}}</h3> -->

                </div>
                <div class="col-md-6 col-sm-12">
                    <div>
                        <button @click="$refs.branchManager.show()" class="btn btn-outline-primary float-right">Manage Stores</button>
                    </div>

                </div>
            </div>
            <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
            <h3 class="h3">Store settings</h3>
            <small>View and update your store details </small>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="float-right">
                    <button @click="saveCompanyDetails" class="btn btn-primary px-3">Save Changes</button>
                </div>
                </div>
                </div>
            <div class="container text-left mb-5">
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Company name <small class="text-danger">*</small></h6>
                        <small>
                            Appears on receipts, invoices, and more
                        </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <input class="form-control" v-model="companyDetails.name" :placeholder="companyDetails.name" />
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Avatar/Logo</h6>
                        <small>
                            Appears on receipts, invoices, and more
                        </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="d-inline">
                            <img v-if="companyDetails.logo_url ===null" class="img-bordered rounded-circle" style="width: 50px; height: auto;" src="https://via.placeholder.com/510/FFFF00/000000?Text=duka" />
                            <img v-else class="img-bordered rounded-circle" :src="companyDetails.logo_url" style="width: 50px; height: auto;" />
                            <a v-b-modal.modal-3 title="Edit Company Profile" class="btn btn-outline-dark mx-2 rounded"> Choose </a><span>JPG, GIF or PNG. 1MB Max.</span>
                        </div>
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Company Phone Number <small class="text-danger">*</small></h6>
                        <small>
                            Where customers can contact you for support. Appears on receipts and invoices.
                        </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <input class="form-control" v-model="companyDetails.phone" :placeholder="companyDetails.phone" />
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="pt-3">Email</h6>
                        <small>
                            Where customers can contact you for support. Appears on receipts and invoices.
                        </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <input class="form-control" v-model="companyDetails.email" :placeholder="companyDetails.email" />
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="pt-3">Country</h6>
                        <small>This will guide on currency. To be displayed </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <select class="form-control" v-model="companyDetails.companysettings.country">
                            <option value="null">Choose Country</option>
                            <option :value="{key,value}" v-for="(value,key) in countriesData" :key="value.country" >{{ value.country }}</option>
                        </select>
                     </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="pt-3">Address</h6>
                        <small>Where customers can contact you for support. Appears on receipts and invoices. </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <input class="form-control" v-model="companyDetails.address" :placeholder="companyDetails.address" />
                    </div>
                </div>

                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="pt-3">Business Type</h6>
                        <small>The kind of business you do like restaurant, hardware etc </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <input class="form-control" v-model="companyDetails.industry" :placeholder="companyDetails.industry" />
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="pt-3">KRA Pin</h6>
                        <small>Your KRA PIN to help in filing of returns on verification this will appear on your receipts and invoice</small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <input class="form-control" v-model="companyDetails.krapin" :placeholder="companyDetails.krapin" />
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Feature toggles</h6>
                        <small>
                              Taxes, discounts, module toggles (KDS, Shifts, Reservations, Payroll, Manufacturing,
                              Invoices &amp; Quotes, Subscriptions, eTIMS) and other feature switches have moved to
                              <a href="/settings/features">Settings &gt; Features</a>.
                            </small>
                    </div>
                </div>

                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="pt-3">Receipt content</h6>
                        <small>
                              The receipt's extra details and footer message have moved to
                              <a href="/settings/receipt">Settings &gt; Customization</a>.
                            </small>
                    </div>
                </div>


            </div>
        </div>
        <b-modal ref="changeCompanyLogo" id="modal-3" hide-footer static>
            <h2 class="text-center text-dark py-2">Update Company Logo</h2>
            <form @submit.prevent="changeCompanyLogo">
                <fileuploader description="Max file size 2MB, only .png,jpeg allowed"></fileuploader>
                <b-button type="submit" variant="primary" class="btn-block my-2">Save Logo</b-button>
            </form>
        </b-modal>
        <branch-manager-modal ref="branchManager" />
    </div>
</template>

<script>
import countriesJson from './countriesData.json';
import {mapGetters} from 'vuex'
import clearCompanyScopedCache from '../../services/companyCache'
    export default {
        name: "profile",
        data() {
            return {
                companyDetails: {
                    name: '',
                    email: '',
                    phone: '',
                    address: '',
                    krapin: '',
                    business_type: '',
                    town: '',
                    building: '',
                    street: '',
                    configs: '',


                    companysettings:{
                        enable_taxes:0,
                        enable_tims:0,
                        enable_shifts:0,
                        enable_discounts:0,
                        enable_order_discount:1,
                        enable_product_discount_campaigns:0,
                        country:null,
                    }
                },
                settingsLoaded: false,
                selectedBranch:0,
                companyBranches:[],

                newStore:{
                    name:'',
                    copyInventory:false,
                    copySettings:0,
                    switchToNew:1,
                    qtyToZero:false,
                    copyInventoryFrom:''
                },
                countriesData: countriesJson
            }
        },
        computed:{
            ...mapGetters(['userDetails']),

        },
        watch: {
            'userDetails.company'(company, old) {
                if (company && !old) this.getUserCompanyDetails()
            },
        },

        mounted() {
            this.getUserCompanyDetails()
            this.getCompanySettings()

            if (new URLSearchParams(window.location.search).get('openBranches')) {
                this.$nextTick(() => this.$refs.branchManager && this.$refs.branchManager.show())
            }
        },
        methods: {
            createNewStore(e)
            {
                e.preventDefault()
                this.newStore.copyInventoryFrom = this.companyDetails.id;
                axios.post('/api/create-store',{...this.newStore}).then(results=>{

                    if(results.status === 200)
                    {
                        this.$refs['create-store-modal'].hide();
                        // if(this.newStore.switchToNew) {
                        //     // this.selectedBranch = results.data.id
                        //     window.location.reload()
                        // }
                    }
                }).catch(e=>{
                    console.log(e)
                })


            },
            async getCompanySettings()
            {
                try{
                    await axios.get('/api/settings')
                    .then(results=>{
                        this.companyDetails.companysettings = results.data
                        this.settingsLoaded = true
                    }).catch(errors => {

                    });
                }
                catch(e){
                    console.error(e)
                }

            },
            creatStoreModal()
            {
        const modalMessage = (this.userDetails.companybranches.length > 10) ? `You have exceeded branch limit. You currently have ${this.userDetails.companybranches.length} branches. Email ${this.$platformBrand.salesEmail}` : `You currently have ${this.userDetails.companybranches.length} branches. This will add an extra cost to your monthly billing`
        this.$bvModal.msgBoxConfirm(modalMessage, {
          title: (this.userDetails.companybranches.length > 10) ? "Limit reached." : "Confirm company branch creation",
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'No Skip',
          cancelTitle: 'Yes Create Branch !',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(value => {

            if(value)
            {


            }
            else{
                if(this.userDetails.companybranches.length < 10)
                {
                    this.$refs['create-store-modal'].show()
                }

            }

          })
          .catch(err => {
            // An error occurred
          })

            },
            changeCompanyLogo() {

                let imagefilename = document.getElementById('filename').value;
                axios.post('/api/update-company-logo', {
                        companyId: this.companyDetails.id,
                        companyLogo: imagefilename
                    })
                    .then(result => {
                        this.$refs['changeCompanyLogo'].hide()
                        this.$toasts.push({
                            type: 'success',
                            message: result.data.message
                        })
                        this.companyDetails.logo_url = result.data.url
                    }).catch(errors => {
                        console.log(errors.message)
                    });
            },
            getUserCompanyDetails() {
                // userDetails is {} until /api/user has loaded (e.g. right after
                // saving, which clears it and reloads) - the watcher fills it in then.
                const company = this.userDetails && this.userDetails.company
                if (company) {
                    const settings = this.settingsLoaded ? this.companyDetails.companysettings : company.companysettings
                    this.companyDetails = { ...company, companysettings: settings || {} }
                }


            },
            // ─────────────────────────────────────────────────────────────────

            saveCompanyDetails() {
                axios.post('/api/settings/general', { ...this.companyDetails
                }).then(results => {
                    if(results.status===200)
                    {
                        this.$toasts.push({
                        type: 'success',
                        message: "Company details have updated"
                    })
                    // Without this, the reload below just shows the same
                    // stale cached company details for up to 5 more minutes
                    // (BottomMenu.vue's getUserCompanyDetails TTL cache).
                    clearCompanyScopedCache()
                    window.localStorage.removeItem('userDetails')
                    window.location.reload()
                    }

                }).catch(errors => {
                })
            }
        },
    }
</script>

<style scoped>

</style>
